import award1 from "../assets/award1.svg";
import award2 from "../assets/award2.svg";
import award3 from "../assets/award3.svg";
import award4 from "../assets/award4.svg";
import award5 from "../assets/award5.svg";
import award6 from "../assets/award6.svg";
import award7 from "../assets/award7.svg";
import award8 from "../assets/award8.svg";
import award9 from "../assets/award9.svg";
import award10 from "../assets/award10.svg";
import award11 from "../assets/award11.svg";
import award12 from "../assets/award12.svg";

import testimonial1 from "../assets/testimonial.jpg";
import testimonial2 from "../assets/testimonial2.jpg";
import testimonial3 from "../assets/testimonial3.jpg";
import testimonial4 from "../assets/testimonial4.jpg";
import testimonial5 from "../assets/testimonial5.jpg";
import testimonialVideo from "../assets/parentShareVideo.mp4";
import testimonialmobile1 from "../assets/mobileTestimonial1.jpg";
import testimonialmobile2 from "../assets/mobileTestimonial2.jpg";
import testimonialmobile3 from "../assets/mobileTestimonial3.jpg";
import testimonialmobile4 from "../assets/mobileTestimonial4.jpg";
import testimonialmobile5 from "../assets/mobileTestimonial5.jpg";
import testimonialmobile6 from "../assets/mobileTestimonial6.jpg";

import galleryImg1 from "../assets/image1.svg";
import galleryImg2 from "../assets/image2.svg";
import galleryImg3 from "../assets/image3.svg";
import galleryImg4 from "../assets/image4.svg";
import galleryImg5 from "../assets/image5.svg";
import galleryImg6 from "../assets/image6.svg";
import galleryImg7 from "../assets/image7.svg";
import galleryImg8 from "../assets/image8.svg";


//these are commented down as might we need call all these through api only.
// import anchalImg from "../assets/anchal.jpg";
// import tanuImg from "../assets/tanu.jpg";
// import nehaImg from "../assets/neha.jpg";
// import JagritiImg from "../assets/jagriti.jpg";
// import gurmitImg from "../assets/ms-gurmeet-kaur.jpg";
// import VijayImg from "../assets/vijay-gupta.jpg";
// import triptiImg from "../assets/Tripti-Chawla.jpg";
// import GeetanjaliImg from "../assets/Geetanjali.jpg";
// import MeghnaImg from "../assets/meghna.jpg";
// import NamitImg from "../assets/ms-namita-sethi-gurgaon-5.jpg";
// import SeemaImg from "../assets/Seema Anand.jpg";
// import ShaliniImg from "../assets/shalini.jpg";
// import ShrishtiImg from "../assets/SRISHTI-SEHGAL.jpg";
// import SonakshiImg from "../assets/sonakshi.jpg";
// import monikaSinghal from "../assets/Monika-Deepali-11-2021.jpg";
// import NeetiImg from "../assets/SDP_9596-aa RH5 MS Neeti.jpg";
// import DeeptiImg from "../assets/ms-deepti-rhode copy copy.jpeg";
// import RachanaImg from "../assets/ms-rachna-khanna.jpg";
// import SheenuImg from "../assets/Sheenu Narang.jpg";

import parentingImg1 from "../assets/parentingImg1.JPG";
import parentingImg2 from "../assets/parentingImg2.JPG";
import parentingImg3 from "../assets/parentingImg3.JPG";
import parentingImg4 from "../assets/parentingImg4.JPG";
import parentingImg5 from "../assets/parentingImg5.JPG";
import parentingImg6 from "../assets/parentingImg6.JPG";
import parentingImg7 from "../assets/parentingImg7.JPG";
import parentingImg8 from "../assets/parentingImg8.JPG";
import parentingImg9 from "../assets/parentingImg9.JPG";
import mobileMissionImg from "../assets/mobileMission.jpg";
import mobileVisionImg from "../assets/mobileVision.jpg";
import mobileSchoolImg from "../assets/mobileSchool.jpg";
import tabMissionImg from "../assets/tabMission.jpg";
import tabVisionImg from "../assets/tabVission.jpg";
import tabSchoolImg from "../assets/tabSchool.jpg";
import missionImg from "../assets/mission.jpg";
import visionImg from "../assets/vision.jpg";
import preSchoolImg from "../assets/school.jpg";

import AboutLinkImg from "../assets/aboutLinkImg.svg";
import AdmissionLinkImg from "../assets/AdmissionLinkImg.svg";
import ThoughtLinkImg from "../assets/ThoughtLinkImg.svg";
import GalleryLinkImg from "../assets/GalleryImg.svg";
import ColLinkImg from "../assets/ColLinkImg.svg";
import ContactLinkImg from "../assets/Contactimg.svg";

import StoryImg1 from "../assets/story1.jpg";
import StoryImg2 from "../assets/story2.jpg";
import StoryImg3 from "../assets/story3.jpg";
import StoryImg4 from "../assets/story4.jpg";
import StoryImg5 from "../assets/story5.jpg";
import mobileStoryImg1 from "../assets/mobileStory1.jpg";
import mobileStoryImg2 from "../assets/mobileStory2.jpg";
import mobileStoryImg3 from "../assets/mobileStory3.jpg";
import mobileStoryImg4 from "../assets/mobileStory4.jpg";
import mobileStoryImg5 from "../assets/mobileStory5.jpg";

import boyChildImg from "../assets/boychild.svg";
import playImg from "../assets/playredyellow.png";
import boyBoardImg from "../assets/boywithboard.png";
import markerImg from "../assets/childwithmarker.svg";
import heartLogoImg from "../assets/heartImg.svg";
import AdmAwardImg from "../assets/AwardsGirl.svg";
import loveBlossomImg from "../assets/Group.svg"
import HomeImg from "../assets/home3.jpg";
import mobileHomeImg from "../assets/Website-banner-2.png"


import dignitariesHeader from "../assets/dignitariesHeader.jpg"
import mobileDignitariesHeader from "../assets/mobileDignitariesHeader.jpg"
import tabDignitariesHeader from "../assets/tabDignitariesHeader.jpg"
import facilitiesHeaderImg from "../assets/FacilitiesHeader.jpg";
import mobileFacilitiesHeaderImg from "../assets/mobileFacilitiesHeader.jpg";
import tabFacilitiesHeaderImg from "../assets/tabFacilitiesHeader.jpg"
import eventsHeaderImg from "../assets/EventsHeader.jpg";
import mobileEventsHeaderImg from "../assets/mobileEventsHeader.jpg";
import tabEventsHeaderImg from "../assets/tabEventsHeader.jpg"
import activitiesHeaderImg from "../assets/ActivitiesHeader.jpg";
import mobileActivitiesHeaderImg from "../assets/mobileActivitiesHeader.jpg";
import tabActivitiesHeaderImg from "../assets/tabActivitiesHeader.jpg"
import celebrationsHeaderImg from "../assets/CelebrationHeader.jpg";
import mobileCelebrationsHeaderImg from "../assets/mobileCelebrationHeader.jpg";
import tabCelebrationHeaderImg from "../assets/tabCelebrationHeader.jpg"
import positiveParentingHeaderImg from "../assets/PositiveParentingHeader.jpg";
import mobilePositiveParentingHeaderImg from "../assets/mobilePositiveParentingHeader.jpg";
import tabPositiveParentingHeaderImg from "../assets/tabPositiveParentingHeader.jpg";


export const headerImages = {
  dignitariesHeaderImg: dignitariesHeader,
  mobileDignitariesHeaderImg: mobileDignitariesHeader,
  tabDignitariesHeaderImg: tabDignitariesHeader,
  facilitiesHeaderImg: facilitiesHeaderImg,
  mobileFacilitiesHeaderImg: mobileFacilitiesHeaderImg,
  tabFacilitiesHeaderImg: tabFacilitiesHeaderImg,
  eventsHeaderImg: eventsHeaderImg,
  mobileEventsHeaderImg: mobileEventsHeaderImg,
  tabEventsHeaderImg: tabEventsHeaderImg,
  activitiesHeaderImg: activitiesHeaderImg,
  mobileActivitiesHeaderImg: mobileActivitiesHeaderImg,
  tabActivitiesHeaderImg: tabActivitiesHeaderImg,
  celebrationsHeaderImg: celebrationsHeaderImg,
  mobileCelebrationsHeaderImg: mobileCelebrationsHeaderImg,
  tabCelebrationsHeaderImg: tabCelebrationHeaderImg,
  positiveParentingHeaderImg: positiveParentingHeaderImg,
  mobilePositiveParentingHeaderImg: mobilePositiveParentingHeaderImg,
  tabPositiveParentingHeaderImg: tabPositiveParentingHeaderImg,
}




export const homePageImages = {
  homeImg: HomeImg,
  mobileHomeImg : mobileHomeImg,
  boyChildImg: boyChildImg,
  playImg: playImg,
  boyBoardImg: boyBoardImg,
  markerImg: markerImg,
  loveBlossomImg:loveBlossomImg,
  AdmAwardImg: AdmAwardImg,
  heartLogoImg: heartLogoImg,
};

export const storyImages = [
  { img: StoryImg1, mobileImg: mobileStoryImg1 },
  { img: StoryImg2, mobileImg: mobileStoryImg2 },
  { img: StoryImg3, mobileImg: mobileStoryImg3 },
  { img: StoryImg4, mobileImg: mobileStoryImg4 },
  { img: StoryImg5, mobileImg: mobileStoryImg5 },
];

export const aboutImages = {
  mobileMissionImg: mobileMissionImg,
  mobileVisionImg: mobileVisionImg,
  mobileSchoolImg: mobileSchoolImg,
  tabMissionImg: tabMissionImg,
  tabVisionImg: tabVisionImg,
  tabSchoolImg: tabSchoolImg,
  missionImg: missionImg,
  visionImg: visionImg,
  preSchoolImg: preSchoolImg,
};

export const NavbarImages = {
  aboutImg: AboutLinkImg,
  admissionImg: AdmissionLinkImg,
  thoughtImg: ThoughtLinkImg,
  galleryImg: GalleryLinkImg,
  colLinkImg: ColLinkImg,
  contactImg: ContactLinkImg,
};

export const galleryImages = [
  galleryImg1,
  galleryImg2,
  galleryImg3,
  galleryImg4,
  galleryImg5,
  galleryImg6,
  galleryImg7,
  galleryImg8,
];

export const PositiveparentingImages = [
  parentingImg1,
  parentingImg2,
  parentingImg3,
  parentingImg4,
  parentingImg5,
  parentingImg6,
  parentingImg7,
  parentingImg8,
  parentingImg9,
];




// export const teamMembers = [
//   {
//     name: "Ms. Anchal Agnihotri",
//     role: "Mentor",
//     image: anchalImg,
//   },
//   {
//     name: "Ms. Tanu Chumber",
//     role: "Head Admissions",
//     image: tanuImg,
//   },
//   {
//     name: "Ms. Neha Loyal",
//     role: "Head Operations",
//     image: nehaImg,
//   },
//   {
//     name: "Ms. Jagriti Chawla",
//     role: "Head Operations",
//     image: JagritiImg,
//   },
//   {
//     name: "Ms. Gurmeet Kaur",
//     role: "Zonal Operations Head (Outstation Branches)",
//     image: gurmitImg,
//   },
//   {
//     name: "Shri Vijay Gupta",
//     role: "",
//     image: VijayImg,
//   },
//   {
//     name: "Ms. Tripti Chawla",
//     role: "",
//     image: triptiImg,
//   },
//   {
//     name: "Ms. Jagriti Chawla",
//     role: "Punjabi Bagh",
//     image: JagritiImg,
//   },
//   {
//     name: "Ms. Geetanjali Kukreja",
//     role: "Gurugram Sector-40",
//     image: GeetanjaliImg,
//   },
//   {
//     name: "Ms. Meghna",
//     role: "Gurugram (Sector-57)",
//     image: MeghnaImg,
//   },
//   {
//     name: "Ms. Namita Sethi",
//     role: "Gurugram (Sector-5)",
//     image: NamitImg,
//   },
//   {
//     name: "Ms. Seema Anand",
//     role: "Gurugram (Sector 9A)",
//     image: SeemaImg,
//   },
//   {
//     name: "Ms. Shalini",
//     role: "Gurugram (Sector-49)",
//     image: ShaliniImg,
//   },
//   {
//     name: "Ms. Srishti Sehgal",
//     role: "Indirapuram",
//     image: ShrishtiImg,
//   },
//   {
//     name: "Dr. Sonakshi Sharma",
//     role: "Dwarka Sector-17",
//     image: SonakshiImg,
//   },
//   {
//     name: "Ms. Monika Singhal",
//     role: "Deepali",
//     image: monikaSinghal,
//   },
//   {
//     name: "Ms. Neeti",
//     role: "Rohini-5",
//     image: NeetiImg,
//   },
//   {
//     name: "Ms. Deepti Rhode",
//     role: "Pitampura",
//     image: DeeptiImg,
//   },
//   {
//     name: "Ms. Rachna Khanna",
//     role: "Ashok Vihar",
//     image: RachanaImg,
//   },
//   {
//     name: "Ms. Sheenu Narang",
//     role: "Vivek Vihar & Noida-31",
//     image: SheenuImg,
//   },
// ];

export const awards = [
  {
    name: "Most Promising Enterprise Award",
    role: "Mumbai,India,2009",
    image: award1,
  },
  {
    name: "Gold Lion in Design",
    role: "Cannes, France, 2011",
    image: award2,
  },
  {
    name: "The Golden Peacock Award",
    role: "London, England, 2010",
    image: award3,
  },
  {
    name: "Outstanding Woman Entrepreneur ",
    role: "New Delhi,India, 2007",
    image: award4,
  },
  {
    name: "No. 1 Teacher's Training Provider",
    role: "New Delhi, India, 2012",
    image: award5,
  },
  {
    name: "Majestic Five Continents Award",
    role: "Berlin, Germany, 2016",
    image: award6,
  },
  {
    name: "New York Festivals",
    role: "New York, USA, 2009",
    image: award7,
  },
  {
    name: "Curriculum books recognized among finest in education",
    role: "Goa, India, 2014",
    image: award8,
  },
  {
    name: "White Swan Award for Most Influential Brand in Education",
    role: "Mumbai,India, 2016",
    image: award9,
  },
  {
    name: "Curriculum books recognized among finest in education",
    role: "New York, USA, 2014",
    image: award10,
  },
  {
    name: " Top 150 World's Greatest Brands in Education",
    role: "Abu Dhabi, UAE, 2016",
    image: award11,
  },
  {
    name: "AsiaOne Pride of the Nation Award",
    role: "Mumbai, India, 2016",
    image: award12,
  },
];

export const testimonialImages = [
  {
    img: testimonial1,
    link: "https://www.youtube.com/embed/MMpfiusZzEQ",
    mobileImg: testimonialmobile1,
  },
  {
    img: testimonial2,
    link: "https://www.youtube.com/embed/_18da76sHtA",
    mobileImg: testimonialmobile2,
  },
  {
    img: testimonial3,
    link: "https://www.youtube.com/embed/4M9_TW4Xmow",
    mobileImg: testimonialmobile3,
  },
  {
    img: testimonial4,
    link: "https://www.youtube.com/embed/xg838jUaZGM",
    mobileImg: testimonialmobile4,
  },
  {
    img: testimonial5,
    link: "https://www.youtube.com/embed/q4cO1C-lVHo",
    mobileImg: testimonialmobile5,
  },
  {
    img: testimonial1,
    link: "https://www.youtube.com/embed/d2RiamznmMU",
    mobileImg: testimonialmobile6,
  },
  {
    img: testimonial2,
    link: testimonialVideo,
    mobileImg: testimonialmobile2,
  },
];

export const missionData = [
  {
    heading: "Transformation of the Education system",
    subheading:
      "To revolutionize the education system so that children are imparted 'Education for Life' which encompasses not only knowledge but also enhances the talents and life skills necessary for the holistic development of the child.",
  },
  {
    heading: "Transformation of Parenting",
    subheading:
      "To guide and enlighten parents about positive parenting so as to enable them to make their parenting experience richer, more joyful and more rewarding.",
  },
  {
    heading: "Transformation in the role and status of teachers",
    subheading:
      "To elevate the status and widen the horizons of teachers by equipping them with knowledge, expertise and skills required to transform them into leaders in education.",
  },
  {
    heading: "Transformation of the society",
    subheading:
      "To awaken humanity in people and seek their support in taking up projects for the welfare of underprivileged children so that they can live in a better world.",
  },
];

export const pageRedirects = [
  { path: "/vision-mission.php", redirectedPath: "/about" },
  { path: "/our-story.php", redirectedPath: "/about" },
  { path: "/management-team.php", redirectedPath: "/about#groups" },
  { path: "/awards.php", redirectedPath: "/about" },
  { path: "/positive-parenting.php", redirectedPath: "/positiveParenting" },
  {
    path: "/what-parents-say-video.php",
    redirectedPath: "/positiveParenting",
  },
  { path: "/infrastructure.php", redirectedPath: "/about" },
  { path: "/why-motherspride.php", redirectedPath: "/about" },

  //next

  
  //next

  { path: "/levels-of-learning.php", redirectedPath: "/activities" },
  { path: "/activities.php", redirectedPath: "/activities" },
  { path: "/stage-exposure-activity.php", redirectedPath: "/activities" },

  //next
  { path: "/admission-open.php", redirectedPath: "/admission" },
  { path: "/class-group.php", redirectedPath: "/admission" },
  { path: "/list-of-holidays.php", redirectedPath: "/calendar" },
  { path: "/facilities-mothers-pride.php", redirectedPath: "/facilities" },
  { path: "/stage-exposure-activity.php", redirectedPath: "/activities" },
  { path: "/curricular-activity.php", redirectedPath: "/activities" },
  { path: "/co-curricular-activity.php", redirectedPath: "/activities" },
  {
    path: "/sports-activities-activity.php",
    redirectedPath: "/activities",
  },
  {
    path: "/excursions-activities-activity.php",
    redirectedPath: "/activities",
  },
  { path: "/meeting-with-dignitaries-mp.php", redirectedPath: "/events" },
  { path: "/celebrations-mothers-pride.php", redirectedPath: "/events" },
  { path: "/events-mothers-pride.php", redirectedPath: "/events" },
  { path: "/baisakhi.php", redirectedPath: "/events" },
  { path: "/news/shubh-navratri-to-all/", redirectedPath: "/events" },
  {
    path: "/news/eid-mubarak-may-the-almighty-bless-you-with-joy-prosperity/",
    redirectedPath: "/events",
  },
  { path: "/ganesh-vandana-feb-27-shift-2.php", redirectedPath: "/events" },
  { path: "/photo-gallery.php", redirectedPath: "/interactiveGallery" },
  {
    path: "https://www.motherspridekids.com/",
    redirectedPath: "/interactiveGallery",
  },
  { path: "/video-gallery.php", redirectedPath: "/interactiveGallery" },
  { path: "/Ecards.php", redirectedPath: "/interactiveGallery" },
  { path: "/campaigns.php", redirectedPath: "/interactiveGallery" },
  { path: "/contact-us.php", redirectedPath: "/getInTouch" },
  { path: "/current-vacancies.php", redirectedPath: "/getInTouch" },
  { path: "/opportunity.php", redirectedPath: "/getInTouch" },
  { path: "/franchise-inquiry-form.php", redirectedPath: "/getInTouch" },
  {
    path: "/registration-information-gurgaon.php",
    redirectedPath: "/getInTouch",
  },
  {
    path: "/registration-information-west.php",
    redirectedPath: "/getInTouch",
  },
  { path: "/franchise-faq.php", redirectedPath: "/getInTouch" },
  { path: "/franchise-inquiry-form.php", redirectedPath: "/getInTouch" },
  { path: "/corporate-partnerships.php", redirectedPath: "/getInTouch" },
  { path: "/corporate-tie-ups.php", redirectedPath: "/getInTouch" },
  { path: "/suggestions-feedback.php", redirectedPath: "/getInTouch" },
  { path: "/careers.php", redirectedPath: "/getInTouch" },
  { path: "/careers.php", redirectedPath: "/curriculumOfLove" },
  {
    path: "/early-childhood-education.php",
    redirectedPath: "/curriculumOfLove",
  },
  {
    path: "/co-curricular-activity.php",
    redirectedPath: "/curriculumOfLove",
  },
  { path: "/photo-gallery.php", redirectedPath: "/dignitory" },
  { path: "/management-team.php", redirectedPath: "/about#groups" },
  { path: "/month-at-a-glance.php", redirectedPath: "/monthcal" },
  { path: "/the-chairperson.php", redirectedPath: "/about#leader" },
  { path: "/what-parents-say.php", redirectedPath: "/positiveParenting" },
  { path: "/positive-parenting.php", redirectedPath: "/positiveParenting" },
  { path: "/weekly-parenting-tip.php", redirectedPath: "/teachingMethod" },
  { path: "/theme-based-learning.php", redirectedPath: "/teachingMethod" },
  { path: "/csr.php", redirectedPath: "/teachingMethod" },
  { path: "/area-wise-branches.php", redirectedPath: "/branch" },
  { path: "/current-mp-branches.php", redirectedPath: "/branch" },
  {
    path: "/best-play-school-gurgaon-sector-57.php",
    redirectedPath: "/branch",
  },
  { path: "/best-play-schools-alipur.php", redirectedPath: "/branch" },
  { path: "/best-play-schools-ambala.php", redirectedPath: "/branch" },
  { path: "/best-play-schools-amritsar.php", redirectedPath: "/branch" },
  {
    path: "/best-play-schools-ashok-vihar-c-block.php",
    redirectedPath: "/branch",
  },
  { path: "/best-play-schools-bahadurgarh.php", redirectedPath: "/branch" },
  { path: "/best-play-schools-bathinda.php", redirectedPath: "/branch" },
  { path: "/best-play-schools-bhiwani.php", redirectedPath: "/branch" },
  { path: "/best-play-schools-burari.php", redirectedPath: "/branch" },
  { path: "/best-play-schools-deepali.php", redirectedPath: "/branch" },
  {
    path: "/best-play-schools-dwarka-sector-17.php",
    redirectedPath: "/branch",
  },
  {
    path: "/best-play-schools-dwarka-sector-6.php",
    redirectedPath: "/branch",
  },
  { path: "/best-play-schools-ganaur.php", redirectedPath: "/branch" },
  {
    path: "/best-play-schools-ghaziabad-kaushambi.php",
    redirectedPath: "/branch",
  },
  {
    path: "/best-play-schools-ghaziabad-nehru-nagar.php",
    redirectedPath: "/branch",
  },
  {
    path: "/best-play-schools-ghaziabad-shastri-nagar.php",
    redirectedPath: "/branch",
  },
  {
    path: "/best-play-schools-greater-kailash.php",
    redirectedPath: "/branch",
  },
  {
    path: "/best-play-schools-greater-noida-delta.php",
    redirectedPath: "/branch",
  },
  { path: "/best-play-schools-gurgaon-57.php", redirectedPath: "/branch" },
  {
    path: "/best-play-schools-gurgaon-sector-40.php",
    redirectedPath: "/branch",
  },
  {
    path: "/best-play-schools-gurgaon-sector-5.php",
    redirectedPath: "/branch",
  },
  {
    path: "/best-play-schools-gurgaon-sector-5_old.php",
    redirectedPath: "/branch",
  },
  {
    path: "/best-play-schools-gurgaon-sector-9a.php",
    redirectedPath: "/branch",
  },
  {
    path: "/best-play-schools-gurugram-sector-49.php",
    redirectedPath: "/branch",
  },
  { path: "/best-play-schools-guwahati.php", redirectedPath: "/branch" },
  { path: "/best-play-schools-hapur.php", redirectedPath: "/branch" },
  {
    path: "/best-play-schools-hisar-bank-colony.php",
    redirectedPath: "/branch",
  },
  {
    path: "/best-play-schools-hisar-sector-17.php",
    redirectedPath: "/branch",
  },
  {
    path: "/best-play-schools-hisar-sunder-nagar.php",
    redirectedPath: "/branch",
  },
  {
    path: "/best-play-schools-indirapuram-habitat-centre.php",
    redirectedPath: "/branch",
  },
  {
    path: "/best-play-schools-indirapuram-niti-khand.php",
    redirectedPath: "/branch",
  },
  {
    path: "/best-play-schools-jammu-sector-221.php",
    redirectedPath: "/branch",
  },
  {
    path: "/best-play-schools-janakpuri-a3.php",
    redirectedPath: "/branch",
  },
  { path: "/best-play-schools-jangpura.php", redirectedPath: "/branch" },
  {
    path: "/best-play-schools-kalyan-vihar.php",
    redirectedPath: "/branch",
  },
  { path: "/best-play-schools-kaushambi.php", redirectedPath: "/branch" },
  {
    path: "/best-play-schools-mansrover-garden.php",
    redirectedPath: "/branch",
  },
  {
    path: "/best-play-schools-ludhiana-omaxe.php",
    redirectedPath: "/branch",
  },
  {
    path: "/best-play-schools-meerut-ganga-nagar.php",
    redirectedPath: "/branch",
  },
  {
    path: "/best-play-schools-muzaffarnagar.php",
    redirectedPath: "/branch",
  },
  { path: "/best-play-schools-narela.php", redirectedPath: "/branch" },
  { path: "/best-play-schools-narnaul.php", redirectedPath: "/branch" },
  {
    path: "/best-play-schools-naveen-shahdara.php",
    redirectedPath: "/branch",
  },
  {
    path: "/best-play-schools-noida-sector-31.php",
    redirectedPath: "/branch",
  },
  { path: "/best-play-schools-palam-dabri.php", redirectedPath: "/branch" },
  {
    path: "/best-play-schools-paschim-vihar.php",
    redirectedPath: "/branch",
  },
  {
    path: "/best-play-schools-pitampura-Rama-Market.php",
    redirectedPath: "/branch",
  },
  { path: "/best-play-schools-pitampura.php", redirectedPath: "/branch" },
  {
    path: "/best-play-schools-punjabi-bagh.php",
    redirectedPath: "/branch",
  },
  {
    path: "/best-play-schools-raj-nagar-extension-ghaziabad.php",
    redirectedPath: "/branch",
  },
  {
    path: "/best-play-schools-rohini-sector-5.php",
    redirectedPath: "/branch",
  },
  { path: "/best-play-schools-rohtak.php", redirectedPath: "/branch" },
  { path: "/best-play-schools-vivek-vihar.php", redirectedPath: "/branch" },
  {
    path: "/best-play-schools-faridabad-sector-82.php",
    redirectedPath: "/branch",
  },

];
